module.exports = new __parcel__URL__("troop_count_circle.a4ccf77c.png").toString();